import React, { useEffect } from 'react';
import RssSiteCmp from './RssSiteCmp';
import RssItemsCmp from '../rss-items/RssItemsCmp';
import RssFeedsCmp from './RssFeedsCmp';
import BreadCrumbCmp from '../../components/common/BreadCrumbCmp';
import { Container } from 'reactstrap';
import { useParams } from 'react-router-dom';
import { useSite } from '../../hooks/useQueries';
import { useAppContext } from '../../providers/AppContext';
import SEOCmp from '../../components/common/SEOCmp';

export default function RssSitePage() {
  const { siteId } = useParams();
  const { setPageTitle } = useAppContext();

  const { data: result } = useSite(Number(siteId));

  useEffect(() => {
    if (result?.result?.site) {
      setPageTitle(result.result.site.siteTitle);
    }
  }, [result, setPageTitle]);

  const siteData = result?.result;

  return (
    <Container>
      {siteData ? (
        <>
          <SEOCmp
            title={siteData.site.siteTitle}
            description={`${siteData.site.siteTitle} gazetesinin tüm haberleri, köşe yazıları ve son dakika gelişmeleri.`}
          />
          <BreadCrumbCmp items={siteData.breadcrumbContainer?.items || []} />
          <RssSiteCmp {...siteData.site} />
          <RssFeedsCmp feeds={siteData.feedList} />
          <div style={{ paddingTop: '20px' }}></div>
          <RssItemsCmp items={siteData.itemList} />
        </>
      ) : (
        <React.Fragment />
      )}
    </Container>
  );
}
